import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Category } from '../category/category.model';
import { ProductService } from '../_services/product.service';
import { CategoryService } from '../_services/category.service';
import { appsettings } from '../shared/app.settings';
import { ProductModal } from '../_services/product-modal.service';
import 'rxjs';
import { OrderByPipe } from '../pipes/orderBy.pipe';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-product-area',
  templateUrl: './product-area.component.html',
  styleUrls: ['./product-area.component.scss']
})
export class ProductAreaComponent implements OnInit {
  link: string;
  id: number;
  country: string;
  language: string;
  categoryName: string;
  product: any;
  categories: Category[] = [];
  products: any;
  child: any;
  filter: any;
  result: any;
  private filterList = [];
  status = false;
  show: boolean;
  isChecked: boolean;
  p: any;
    excepts:any;
  select: any;
  compared: any;
  invisible: string;
  visible: string;
  elections: any;
  value: boolean;
  checkIfOthersAreSelected: boolean;
  public productArray: any = [];
  column: string;
  allCategories: any; 
  parentCategory: any;
  feature: any;
  modalSection: any;
  public selectedCatId: any;
  public modalInvisible: string;
  currentPage: any;
  checkedInputs: any;
  clickEvent() {
    this.status = !this.status;
  }

  constructor(
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private titleService: Title,
    private productService: ProductService,
    private productModal: ProductModal,
    private orderByPipe: OrderByPipe,
    private router: Router
  ) {}

  getProducts(link: string, country: string, language: string): void {
    this.categoryService.getProducts(link, country, language)
      .subscribe(
        resultArray => {
          this.categoryService.category.next(resultArray['categories']);
          this.products = resultArray['products'];
          this.excepts = resultArray['excepts'];
          this.categories = resultArray['categories'];
          this.products = this.orderByPipe.transform(this.products, 'createdAt.date', 'desc');
          this.selectedCatId = this.categories[0].id;
          //console.log(this.products);
          this.showFeature(this.selectedCatId);
          this.titleService.setTitle(this.categories[0].name + ' | ' + appsettings.siteTitle);
          //console.log(this.feature);


            // if(this.feature) {
          //     console.log("active feature");
          //   this.getFilterResult(this.link, this.country, this.language, this.filterList, this.feature);
          // }
          //   this.products = resultArray['products'];
        },
        error => console.log('Error ::' + error)
      );

  }

  showFeature(x){
    this.categoryService.getCategories(this.country, this.language)
      .subscribe(
        resultArray => {
          this.allCategories = resultArray;
          for(let i=0; i < this.allCategories.categories.length ; i++){
              for(let j=0; j < this.allCategories.categories[i].child[0].child.length ; j++){
                if(this.allCategories.categories[i].child[0].child[j].id == x){
                  this.parentCategory= this.allCategories.categories[i].feature;
                }
            }
          }
        },
        error => console.log('Error ::' + error)
      );
  }

  toggleFilter(filtersId) {
    const index = this.filterList.indexOf(filtersId);
    if (index >= 0) {
      this.filterList.splice(index, 1);
    } else {
      this.filterList.push(filtersId);
    }
    if (this.filterList.length > 0) {
      this.getFilterResult(this.link, this.country, this.language, this.filterList);
    } else {
      this.getProducts(this.link, this.country, this.language);
    }
  }

  close() {
    //console.log("close--------------------");
    //console.log(this.productArray);
    this.modalInvisible = "block";
    this.modalSection.classList.remove('d-none');
    this.modalSection.classList.add('d-block');
    //this.visible = "none";
    this.invisible = "none";
    //console.log(this.modalSection);
    //console.log(this.modalSection.classList);
  }

  closeCompare() {
    console.log('closeCompare');
    //this.productArray.isChecked = false;
    
      
    this.productArray = [];
    var allChekced = document.querySelectorAll('.check');
    Array.prototype.forEach.call(allChekced, function(el) {
      el.checked = false;
    })
    this.invisible = "none";  
    this.modalInvisible = "none";
    this.modalSection.classList.add('d-none');
    this.modalSection.classList.remove('d-block');
    this.elections = [];
    this.checkedInputs = [];
    this.checkIfOthersAreSelected = false;


    //this.isChecked = false; 
    //console.log(this.productArray);
    //this.checkIfOthersAreSelected = false;
    //this.product = [];
    //this.elections = [];
    //this.visible = "block";
    //this.invisible = "block";
  }

  goToProduct(link) {
    //this.modalInvisible = "none";
    setTimeout(() => {
      this.router.navigate(['/', this.country, this.language, 'product', link]);
    }, 100);
  }

  setFeature(featureId) {
    this.feature = featureId;
    this.getFilterResult(this.link, this.country, this.language, this.filterList);
  }

  compare(compared) {
    //console.log(compared);
    this.invisible = "block";
    //this.elections = [];

    var index = this.elections.indexOf(compared);
    if (index === -1) {
      this.visible = "block";
      this.invisible = "block";
      
      if (this.elections.length <= 3) {
        //console.log('<=3')
        this.elections.push(compared);
        //console.log(this.elections);
        this.productService.getProduct(compared, this.country, this.language)
          .subscribe(
            resultArray => {
              this.productArray.push(resultArray[0]);
              const productArrayLength = this.productArray.length;
              if (productArrayLength === 1) {
                this.column = 'medium-12';
              } else if (productArrayLength === 2) {
                this.column = 'medium-6';
              } else if (productArrayLength === 3) {
                this.column = 'medium-4';
              } else {
                this.column = 'medium-4';
              }
            },
            error => console.log('Error ::' + error)
          );
      }
      //console.log(this.elections.length);
      if (this.elections.length >= 3) {
        this.checkIfOthersAreSelected = true;
      }
    } else {
      this.elections.splice(index, 1);
      this.productArray.splice(index, 1);
      this.checkIfOthersAreSelected = false;
      if (this.elections.length <= 0) {
        this.visible = "none";
        this.invisible = "none";
      }
    }
    if (this.elections.length <= 0) {
      this.visible = "none";
      this.invisible = "none";
    }
  }

  getFilter(link: string, country: string, language: string): void {
    this.productService.getFilter(link, country, language)
      .subscribe(
        resultArray => {
          this.filter = resultArray;
        },
        error => console.log('Error ::' + error)
      );
  }

  getFilterResult(link: string, country: string, language: string, filterList: Array<{ products }>): void {
    this.productService.getFilterResult(link, country, language, filterList)
      .subscribe(
        resultArray => {
          this.products = resultArray;
        },
        error => console.log('Error ::' + error)
      );
  }

  checkSelected(link: string) {
    //console.log(this.elections);
    if (this.elections.indexOf(link) >= 0) {
      //console.log('gg');
      return true;
    }
    return false;
  }

  sort() {
    if (this.select === 1) {
      this.products = this.orderByPipe.transform(this.products, 'name', 'desc');
    }
     if (this.select === 0) {
      this.products = this.orderByPipe.transform(this.products, 'name', 'asc');
    }
     if (this.select === 2) {
      this.products = this.orderByPipe.transform(this.products, 'createdAt.date', 'desc');
    }
    //console.log(this.select);
  }

  ngOnInit(): void {
    setTimeout(() => {
      $(document).foundation();
    }, 1000);
    this.route.params
      .subscribe(
        (params: Params) => {
          this.feature = this.route.snapshot.queryParamMap.get('feature');
          this.filterList = [];
          this.elections = [];
          //this.productArray = [];
          this.visible = "none";
          this.select = 2;
          //console.log(this.select);
          this.invisible = "none";
          this.modalInvisible = "none";
          this.link = params['link'];
          this.country = params['country'];
          this.language = params['language'];
          this.checkIfOthersAreSelected = false;
          this.getProducts(this.link, this.country, this.language);
          this.getFilter(this.link, this.country, this.language);
          this.productService.product.next(null);
          this.modalSection = document.getElementById('exampleModal8');
          this.currentPage = 1;
          this.checkedInputs = [];
         
        }
      );

  }

  
  onPageChange(_event) {
    // update current page of items
    //console.log('page changed gg');
    //console.log(_event);
    this.currentPage = _event;
    var checkboxArray = document.getElementsByClassName('checkbox-check');
    var selectedArray = [];
    //console.log(checkboxArray);

    
    var that = this;
    Array.prototype.forEach.call(checkboxArray, check1);

    function check1(el) {
      //console.log(el.value);
      var ell = el;
      that.productArray.forEach(function(arr) {
        // console.log(arr.id);
        // console.log('-------------');
        // console.log(ell.value);
        // console.log(ell.getAttribute('value'));
        if(arr.id.toString() == ell.getAttribute('value')) {
          //ell.checked = true;
          
          that.checkedInputs.push(arr.id);
          
          //console.log(ell.getAttribute('checked'));
          //console.log(ell);
        }
        else {
          that.checkedInputs.push(false)
        }
      })
    }

    //console.log(that.checkedInputs);


    // function(el) {
    //   if(this.productArray.includes(el.getAttribute('value'))) {
    //     console.log(this.productArray);
    //     el.checked = true;
    //   }
    // });

  }

}
